import styled, { css } from 'styled-components';
import { Divider, Button } from 'antd';

export const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .create-flow {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
`;

export const FlowContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 -6px;
`;

export const FlowSection = styled.div<{ $direction?: 'row' | 'column' }>`
  flex: 1;
  height: 1px;
  display: flex;
  background-color: #fff;
  flex-direction: ${(props) => props.$direction || 'row'};
  padding: 4px 14px;

  & > * {
    flex: 1;
  }

  ${(props) => {
    if (props.$direction === 'row') {
      return css`
        gap: 20px;

        & > ${VerticalMetricContainer} {
          width: 1px;
        }
      `;
    }

    return css`
      & > ${HorizontalMetricContainer} {
        height: 1px;
      }
    `;
  }}

  & + & {
    border-top: 1.5px solid #e5e5e5;
  }
`;

export const HorizontalDivider = styled(Divider).attrs({ type: 'horizontal' })`
  flex: none;
  width: 100%;
  margin: 4px 0;
`;

export const TrendContainer = styled.div`
  flex: 1;
  overflow: hidden;
  height: 100%;
`;

export const GaugeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const GaugeContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  height: calc(100% - 22px);
`;

export const GaugeValue = styled.div`
  font-size: 22px;
  font-weight: 400;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #575757;
  user-select: none;
`;

export const Value = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #242424;
  user-select: none;
`;

const MetricContainer = styled.div<{ $notAvailable?: boolean }>`
  display: flex;
  padding: 2px 4px;

  ${(props) =>
    props.$notAvailable
      ? css`
          ${Title} {
            color: #868686;
          }
        `
      : css`
          cursor: pointer;

          :hover {
            background-color: #f2f8ff;
          }
        `}
`;

export const VerticalMetricContainer = styled(MetricContainer)`
  flex-direction: column;
  gap: 2px;
`;

export const HorizontalMetricContainer = styled(MetricContainer)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > * {
    flex: 1;
  }

  & > ${TrendContainer} {
    flex: 2;
    margin-left: 28px;
  }
`;

export const MetricPlaceholder = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
`;

export const LinkButton = styled(Button).attrs({ type: 'link' })`
  padding-left: 0;
  padding-right: 0;

  &.ant-btn-link {
    color: #0046ff;
  }
`;

export const StyledEventWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding-left: 8px;
  align-items: flex-start;
`;
export const StyledEventName = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 112px;
  margin-left: 20px;

  &::before {
    content: '';
    display: inline-block;
    width: 4.5px;
    height: 4.5px;
    background-color: black;
    border-radius: 100%;
  }
`;

export const Div = styled.div`
  font-size: 14px;
  color: #000000e0;
  font-weight: 400;

  a {
    color: #0046ff;
  }
`;

export const Wrapper = styled.div`
  width: 440px;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
`;
